import React from 'react';
import { Form, Label, Dropdown } from 'semantic-ui-react';

const renderDropbox = ({
  input,
  label,
  customClass,
  errorMessage,
  options,
  required,
  onClick,
  meta: { touched, error },
}) => {
  const showError = errorMessage && touched && error;
  return (
    <Form.Field className={ `${customClass || ''} ${showError ? 'error' : ''} ${required ? 'required' : ''}` }>
      <label>{ label }</label>
      <Dropdown
        { ...input }
        selection
        compact
        search
        selectOnBlur={ false }
        value={ input.value }
        onChange={ (param, data) => { input.onChange(data.value); input.onBlur(); } }
        options={ options }
        onClick={ onClick || function () {} }
      />
      {showError && <Label basic pointing>{ errorMessage }</Label> }
    </Form.Field>
  );
};

export default renderDropbox;
